/* Hi-tek Pets accessibility patch (13 Oct 2026) for stock Horizon 3.3.1 markup.
   Each fix corrects an ARIA role or state that the stock components output in a form
   assistive technology cannot use. Horizon 3.4+ fixes some of these itself; delete the
   matching block here if the theme is ever upgraded.
   htk-head.liquid renders more than once per page, so the script guards against re-running. */
(function () {
  if (window.__htkA11y) return;
  window.__htkA11y = true;

  function hasMenuParent(el) {
    for (var p = el.parentElement; p; p = p.parentElement) {
      var r = p.getAttribute('role');
      if (r === 'menu' || r === 'menubar' || r === 'group') return true;
    }
    return false;
  }

  /* True when the element holds something a keyboard user can actually reach. */
  function hasReachableChild(el) {
    var c = el.querySelectorAll('a[href], button, input, select, textarea, [tabindex]');
    for (var i = 0; i < c.length; i++) {
      var n = c[i];
      if (n.tabIndex < 0 || n.disabled || n.closest('[inert]')) continue;
      if (n.getClientRects().length) return true;
    }
    return false;
  }

  function patch() {
    /* Header menu: the list items are role=presentation, so the wrapping list inside the
       overflow component must be presentational too. */
    document.querySelectorAll('overflow-list').forEach(function (host) {
      var root = host.shadowRoot;
      if (!root) return;
      root.querySelectorAll('ul[part="list"], ul[part="overflow-list"]').forEach(function (ul) {
        if (!ul.hasAttribute('role')) ul.setAttribute('role', 'presentation');
      });
    });

    /* Header "More" button: role=menuitem is only valid inside a menu. Outside one it is
       a plain button. */
    document.querySelectorAll('button[role="menuitem"]').forEach(function (btn) {
      if (!hasMenuParent(btn)) btn.removeAttribute('role');
    });

    /* Carousel dots and thumbnails use aria-selected, which is only valid on tabs. The
       stock CSS keys its styling off aria-selected, so the state stays and the controls
       are given the tab roles it belongs to. */
    document.querySelectorAll('.slideshow-controls__dots, .slideshow-controls__thumbnails').forEach(function (list) {
      var tabs = list.querySelectorAll('button.slideshow-control');
      if (!tabs.length) return;
      list.setAttribute('role', 'tablist');
      if (!list.hasAttribute('aria-label')) list.setAttribute('aria-label', 'Choose a slide');
      list.querySelectorAll(':scope > li').forEach(function (li) { li.setAttribute('role', 'presentation'); });
      tabs.forEach(function (b) { b.setAttribute('role', 'tab'); });
    });

    /* Image strips. A strip that overflows by a pixel or two is a rounding artefact with
       nothing to scroll to, so it is clipped. A strip that really scrolls but holds
       nothing a keyboard can reach is made reachable and given a name. */
    document.querySelectorAll('slideshow-slides[tabindex="-1"]').forEach(function (s) {
      var over = s.scrollWidth - s.clientWidth;
      if (over <= 0) return;
      if (over <= 2) { s.style.overflowX = 'clip'; return; }
      if (hasReachableChild(s)) return;
      s.setAttribute('tabindex', '0');
      if (!s.hasAttribute('role')) s.setAttribute('role', 'group');
      if (!s.hasAttribute('aria-label')) s.setAttribute('aria-label', 'Product images');
    });

    /* Wide tables in the guides sit in a .htk-scroll wrapper that scrolls sideways on
       narrow screens. When it actually overflows, make it reachable by keyboard and name
       it; when it fits (wider screens, or after rotating a phone), take that back off. */
    document.querySelectorAll('.htk-scroll').forEach(function (s) {
      var scrolls = s.scrollWidth - s.clientWidth > 1;
      if (scrolls) {
        if (hasReachableChild(s) && !s.hasAttribute('data-htk-scrollable')) return;
        s.setAttribute('tabindex', '0');
        s.setAttribute('role', 'region');
        s.setAttribute('aria-label', 'Table. Scroll sideways to see all columns.');
        s.setAttribute('data-htk-scrollable', '');
      } else if (s.hasAttribute('data-htk-scrollable')) {
        s.removeAttribute('tabindex');
        s.removeAttribute('role');
        s.removeAttribute('aria-label');
        s.removeAttribute('data-htk-scrollable');
      }
    });
  }

  function run() { patch(); setTimeout(patch, 1200); setTimeout(patch, 3000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', patch);
  var resizeTimer;
  window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(patch, 200); });
})();
